import React from 'react';
import { LanguageSelect } from '@components/LanguageSelect';
import { TopMenu } from '@layouts/Header/Header.types';
import { Language } from '@type/common';

interface TopMenuLanguageSelectorProps {
  languages: TopMenu['Languages'];
  defaultLanguage: string;
}

export const TopMenuLanguageSelector = ({
  languages,
  defaultLanguage,
}: TopMenuLanguageSelectorProps) => {
  const select = (item: Language) => {
    window.location.href = item.Href;
  };

  const currentLanguageTitle = () => {
    const lang = languages.filter((i) => i.LanguageCode == window.lang);
    if (lang.length > 0) {
      return lang[0].Name;
    } else {
      return languages[0].Name;
    }
  };

  const languageTitle = currentLanguageTitle();

  return (
    <React.Fragment>
      <div className='c-top-menu-link current-language'>
        <LanguageSelect
          arrow='right'
          list={languages}
          name='Name'
          selectFunction={(item) => select(item)}
          title={defaultLanguage ?? languageTitle}
        />
      </div>
    </React.Fragment>
  );
};
